import { Card, CardContent, CardDescription } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const TextSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('p-4', className);

	// Render
	return (
		<Card className={rootClassName}>
			<CardContent className='gap-2 pt-2 w-full'>
				<CardDescription>
					<Skeleton className='w-1/2' />
				</CardDescription>
				<CardDescription>
					<Skeleton className='w-2/3' />
				</CardDescription>
			</CardContent>
		</Card>
	);
};

export { TextSkeleton };
